import { makeStyles } from '@material-ui/core/styles';
import fonts from 'styles/fonts';
import { colors } from 'styles/colors';

const useStyles = makeStyles({
  presentation: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
  },
  modalPresentation: {
    outline: 'none',
  },
  modalCard: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '4px',
    background: colors.white,
    boxShadow:
      '0px 24px 38px rgba(0, 0, 0, 0.14), 0px 9px 46px rgba(0, 0, 0, 0.12), 0px 11px 15px rgba(0, 0, 0, 0.2)',
    maxHeight: 'calc(100vh - 34px)',
    width: (props: { width: string }) => `${props.width}`,
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0 24px',
    alignItems: 'center',
    minHeight: '67px',
    width: '100%',
    borderBottom: `1px solid ${colors.lightGray}`,
  },
  headerTitle: {
    fontSize: fonts.sizes.medium,
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.15px',
    lineHeight: '24px',
    color: colors.black,
  },
  headerIcon: {
    cursor: 'pointer',
  },
  modalBody: {
    display: 'flex',
    padding: '12px 24px',
    overflowY: 'auto',
  },
  modalFooter: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    minHeight: '58px',
    padding: '0 24px',
  },
  modalFooterActionsButtons: {
    '& > * + *': {
      marginLeft: '16px',
    },
  },
  commentContent: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '270px',
    overflowY: 'auto',
    width: '100%',
    padding: '12px 0',
  },
  addMoreCommentContent: {
    width: '100%',
    margin: '0 0 16px 0',
  },
  commentItem: {
    marginBottom: '16px',
  },
  commentText: {
    fontSize: fonts.sizes.small,
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.25px',
    lineHeight: '20px',
    color: `${colors.black} !important`,
  },
  cardRoot: {
    border: '1px solid rgba(0, 0, 0, 0.12)',
  },
  cardHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  cardHeaderText: {
    fontSize: fonts.sizes.xsmall,
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.4px',
    lineHeight: '16px',
    color: colors.black,
  },
  emptyCommentContent: {
    marginTop: '16px',
  },
  emptyCommentText: {
    textAlign: 'center',
    color: colors.black,
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.25px',
    lineHeight: '20px',
    fontSize: fonts.sizes.small,
  },
});

export default useStyles;
